import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const yunusAnbiya87: Quote = {
  id: "yunus-anbiya-87",
  name: "Doa dari Kegelapan",
  emoji: "🌊",
  category: "Doa & Dzikir",
  description:
    "Nabi Yunus berdoa dari **perut ikan dalam kegelapan laut**. Doa ini begitu dahsyat, Rasulullah ﷺ bilang: tidak ada Muslim yang berdoa dengannya kecuali Allah kabulkan.",
  detail:
    "Nabi Yunus 'alaihissalam meninggalkan kaumnya tanpa izin Allah, lalu ditelan ikan besar. Dalam kegelapan perut ikan, di dasar laut, di kegelapan malam — beliau berdoa: \"Tidak ada Tuhan selain Engkau, Maha Suci Engkau. Sungguh, aku termasuk orang-orang yang zalim.\" Allah selamatkan beliau. Rasulullah ﷺ bersabda bahwa **doa ini tidak pernah ditolak** jika dibaca dengan sungguh-sungguh (HR. Tirmidzi 3505).",
  tldr: "Doa Yunus dari titik terendah — Allah jamin tidak pernah ditolak.",
  story: createQuoteStory("Doa dari Kegelapan", "🌊", [
    { hook: {
      title: "Pernah merasa terjebak dan gak ada jalan keluar?",
      body: "Gelap, sendirian, dan semua pintu rasanya sudah tertutup. Ada seorang nabi yang berdoa di **titik paling rendah yang bisa dibayangkan** — dan Allah jawab.",
    } },
    { source: {
      arabic: "لَا إِلَٰهَ إِلَّا أَنتَ سُبْحَانَكَ إِنِّي كُنتُ مِنَ الظَّالِمِينَ",
      body: "Tidak ada Tuhan selain Engkau, **Maha Suci Engkau**. Sungguh, aku termasuk **orang-orang yang zalim.**",
      title: "QS. Al-Anbiya: 87",
    } },
    { reveal: {
      body: "Yunus tidak minta diselamatkan. Dia **mengaku salah** dan **mengagungkan Allah**. Itu saja. Dari perut ikan, di dasar laut, dalam kegelapan tiga lapis — dan Allah mendengar.",
    } },
    { insight: {
      title: "Kenapa doa ini begitu dahsyat?",
      body: "Rasulullah ﷺ bersabda: **\"Tidak ada seorang Muslim yang berdoa dengan doa ini kecuali Allah mengabulkannya.\"** (HR. Tirmidzi 3505)\n\nStrukturnya sederhana: tauhid, tasbih, pengakuan dosa. Tanpa basa-basi, tanpa syarat. **Semakin kamu merasa terpuruk, semakin doa ini cocok untukmu.**",
    } },
    { engagement: {
      title: "Kalau Yunus didengar dari perut ikan...",
      body: "Kamu pikir Allah gak dengar doamu dari kamar yang gelap? **Dia Maha Mendengar, di mana pun kamu berada.**",
    } },
  ]),
  related: ["zakaria-anbiya-89", "sabar-baqarah-153"],
};
